// Contenu facilement modifiable du site Moum's
export const CONTACT = {
  phone: "06 56 66 36 70",
  phoneRaw: "+33656663670",
  whatsapp: "33656663670",
  email: "mouminebelba@gmail.com",
  zone: "Toute l'Île-de-France",
  instagram: "https://www.instagram.com/moums.glaces/",
  facebook: "https://www.facebook.com/profile.php?id=61591405320524",
  mapsQuery: "Île-de-France France",
};

export const LOGO = "/moums-logo.png";

// Informations légales — facilement modifiables
export const LEGAL = {
  nomCommercial: "MOUM'S",
  statut: "Micro-entrepreneur",
  responsable: "Belbachir Abdelmoumine",
  adresse: "",
  email: "mouminebelba@gmail.com",
  telephone: "06 56 66 36 70",
  siret: "105 735 989 00011",
  villeImmatriculation: "Stains",
  tva: "TVA non applicable, article 293 B du Code général des impôts (franchise en base de TVA).",
  hebergeur: {
    nom: "Emergent Labs Inc.",
    adresse: "548 Market St, PMB 62294, San Francisco, CA 94104-5401, États-Unis",
    tel: "support@emergent.sh",
  },
  moyensPaiement: "Espèces et virement bancaire. Un acompte de 10% est demandé pour confirmer la réservation.",
  zones: "Stains (93240), Seine-Saint-Denis et toute l'Île-de-France.",
};

export const PRESTATIONS = [
  { titre: "Mariages", desc: "Une touche gourmande et élégante pour le plus beau jour." },
  { titre: "Anniversaires", desc: "Petits et grands craquent pour la glace à l'italienne." },
  { titre: "Baptêmes", desc: "Un moment doux et convivial pour toute la famille." },
  { titre: "Communions", desc: "Une gourmandise festive pour célébrer ensemble." },
  { titre: "Baby showers", desc: "Une animation tendre et pastel pour l'arrivée de bébé." },
  { titre: "Gender reveals", desc: "Le suspense en version glacée et colorée." },
  { titre: "Fêtes privées", desc: "Régalez vos invités avec un stand qui fait fondre." },
  { titre: "Événements d'entreprise", desc: "Séminaires, afterworks, inaugurations : effet garanti." },
  { titre: "Inaugurations", desc: "Marquez les esprits dès l'ouverture." },
  { titre: "Associations", desc: "Une animation chaleureuse pour vos rassemblements." },
  { titre: "Festivals & salons", desc: "Un stand qui attire et fidélise le public." },
  { titre: "Écoles & collectivités", desc: "Kermesses et fêtes scolaires inoubliables." },
  { titre: "Événements sportifs", desc: "La récompense fraîche après l'effort." },
  { titre: "Tout autre événement", desc: "Une idée ? On la rend gourmande sur mesure." },
];

export const PARFUMS = [
  { nom: "Vanille", emoji: "🍦", desc: "Onctueuse et parfumée, notre valeur sûre.", img: "https://images.pexels.com/photos/17864043/pexels-photo-17864043.jpeg", accent: "#F3EAD8" },
  { nom: "Fraise", emoji: "🍓", desc: "Fruitée et délicatement rosée, un vrai régal.", img: "https://images.pexels.com/photos/6431594/pexels-photo-6431594.jpeg", accent: "#F8B7C2" },
  { nom: "Chocolat", emoji: "🍫", desc: "Intense et généreuse pour les gourmands.", img: "https://images.unsplash.com/photo-1580915411954-282cb1b0d780", accent: "#7A5A4E" },
];

const IMG = "https://static.prod-images.emergentagent.com/jobs/1e0fc948-3387-4e4f-b2bb-79ec928a7fe3/images/";

// Modifiable facilement : ajoutez / retirez des toppings (nom + image)
export const TOPPINGS = [
  { nom: "M&M's", img: IMG + "352337e346ac04864e6a613ee6b255a3635c8c5e5f5d3789265be4f4aaca21e3.png" },
  { nom: "Oreo", img: IMG + "ff7f6d493b9a26e362d40810cdf204cce5a0a5794d8b413193f083b8582636d4.png" },
  { nom: "Spéculoos", img: IMG + "9c47fe0cc7f565cf003cc7174e5921c2902b810fe41f87794d0e8f491ab4dd16.png" },
  { nom: "Smarties", img: IMG + "edba5bd5e087164756ed66d7fc245143daee36dca3da744a440c9fd4510fe2ce.png" },
  { nom: "Daim", img: IMG + "b4024157a1e2d88d91ea368cfb9683f51b06cdf3111a2919847c6d8b21494d9b.png" },
  { nom: "KitKat", img: IMG + "bce8af1b584a2ea2ec0a26da95b641d1e5d441a5112d5830075f11b38ffb7ea9.png" },
  { nom: "Noix de coco", img: IMG + "e811c3a6fa6136135121458287f41bfcf7418c5aadd066ded5fe26dea127b72e.png" },
  { nom: "Cacahuète", img: IMG + "e1cc4244e06a4b05feed2d34074f49b94a6ef2bed17ca230efd44f1f5dcb042c.png" },
  { nom: "Amande", img: IMG + "8f938efdaa34c32ffc0a8b4ba7dcc6d06dde55578fa84146ce8453872ec13105.png" },
  { nom: "Vermicelles colorés", img: IMG + "559dc557b02ba45b386f26fe9d28563c5f3b79ab716a38ab7fc7846ce1bf8705.png" },
];

// Modifiable facilement : ajoutez / retirez des coulis (nom + image)
export const COULIS = [
  { nom: "Chocolat", img: IMG + "df5873648edb19b65bcc7d2b87e6a5a7145b857b1b172a7520ba5da844e35e60.png" },
  { nom: "Caramel", img: IMG + "5ca103ca6c7097c0d4f0015a80da2eb48a9b501b935769f3c241c5fff035b586.png" },
];

export const AVANTAGES = [
  { titre: "Produits de qualité", desc: "Production française et ingrédients soigneusement sélectionnés pour un goût irréprochable." },
  { titre: "Service professionnel", desc: "Ponctualité, hygiène et sourire tout au long de votre événement." },
  { titre: "Installation sur place", desc: "On s'occupe de tout : matériel, montage et service." },
  { titre: "Adapté à tous les événements", desc: "Du mariage intime au grand festival, on s'adapte." },
  { titre: "Devis personnalisé", desc: "Une offre claire, sur mesure et sans engagement." },
  { titre: "Prestation clé en main", desc: "Vous profitez, on gère la gourmandise de A à Z." },
  { titre: "Service convivial", desc: "Une animation chaleureuse qui régale vos invités." },
];

export const FAQ = [
  { q: "Combien coûte une prestation ?", a: "Chaque prestation est personnalisée selon le nombre d'invités, la durée et les options choisies. Demandez votre devis gratuit : nous vous répondons rapidement avec une offre claire et sans engagement." },
  { q: "Jusqu'où vous déplacez-vous ?", a: "Nous intervenons dans toute l'Île-de-France : Paris, Seine-Saint-Denis, Val-d'Oise, Hauts-de-Seine, Val-de-Marne, Essonne, Yvelines et Seine-et-Marne. Un doute sur votre commune ? Contactez-nous !" },
  { q: "Combien de personnes pouvez-vous servir ?", a: "De quelques dizaines à plusieurs centaines d'invités. Indiquez-nous le nombre de convives dans le formulaire et nous adaptons la prestation." },
  { q: "Peut-on choisir plusieurs parfums ?", a: "Oui ! Vanille, fraise et chocolat sont disponibles, ainsi qu'un large choix de toppings et de coulis pour composer la glace parfaite." },
  { q: "Combien de temps dure la prestation ?", a: "La durée est définie ensemble selon votre événement. Nous restons flexibles pour s'adapter au rythme de votre journée." },
  { q: "Comment obtenir un devis ?", a: "Remplissez notre formulaire de devis en ligne ou contactez-nous par téléphone / WhatsApp. Vous recevrez un devis personnalisé, puis il ne reste qu'à le valider." },
];

export const TEMOIGNAGES = [
  { nom: "Sarah L.", event: "Mariage à Pierrefitte", texte: "Un stand magnifique et des glaces délicieuses ! Nos invités en parlent encore. Service au top et très pro." },
  { nom: "Karim B.", event: "Anniversaire à Stains", texte: "Moum's a fait sensation auprès des enfants comme des adultes. Installation nickel et beaucoup de gourmandise." },
  { nom: "Émilie R.", event: "Baby shower à Saint-Denis", texte: "Une équipe adorable, des glaces onctueuses et une déco parfaite pour notre baby shower. Je recommande à 100%." },
];

export const ETAPES = [
  { n: "01", titre: "Découverte", desc: "Explorez nos prestations et nos saveurs." },
  { n: "02", titre: "Formulaire", desc: "Remplissez votre demande détaillée." },
  { n: "03", titre: "Devis personnalisé", desc: "Recevez une offre sur mesure." },
  { n: "04", titre: "Validation", desc: "Validez votre devis en toute simplicité." },
  { n: "05", titre: "Confirmation", desc: "On confirme et on s'occupe de tout le jour J." },
];

// Galerie : photos Moum's retouchées en qualité studio premium
export const GALLERY = [
  { src: IMG + "02ee967fd4ee37330cb5e3bc0a5b3ec40d2dfbe7f7b77b6491792f18e2f4c5e5.png", caption: "Grande coupe familiale à partager" },
  { src: IMG + "27eeda1886a7a637170cfe5a786e57fd0334c7efe3dcd4cddcb2ba7e2c04afad.png", caption: "Cornet maxi, duo de parfums" },
  { src: IMG + "15f035f041ec9e436a1411103985a17623473365e391f9041bb045c239fab9d7.png", caption: "Cornet vanille, coulis chocolat" },
  { src: IMG + "acdb31401783e33f3f76cef586d0b3b1539ea8e15f649978ce67a9b514f744e2.png", caption: "Cornet vanille & éclats d'Oreo" },
  { src: "https://images.pexels.com/photos/34890758/pexels-photo-34890758.jpeg", caption: "Un stand gourmand pour vos événements" },
  { src: "https://images.unsplash.com/photo-1636564499112-6113e73c504a", caption: "La douceur de la glace à l'italienne" },
];
